//Data API
export const NikitaPortalUrlFunct = () => {
    return getOrigin() + "/nikita-portal/"
}

export const ImageUrl  = () => {
    return getOrigin() + "/report/reportController/getImage";
}

//Autohorization and token andpoint AZURE
export const authorization_endpoint = "https://login.microsoftonline.com/86fb8e1f-02bd-4434-96ae-aa3ef467ada8/oauth2/v2.0/authorize";
export const token_endpoint = "https://login.microsoftonline.com/86fb8e1f-02bd-4434-96ae-aa3ef467ada8/oauth2/v2.0/token";
export const tokenScope = "api://29cccde1-c00e-48d8-a238-105895089d52/user.read"

//redirect to login page
export const client_id = "29cccde1-c00e-48d8-a238-105895089d52"

//Same redirect uri federated in Azure AD
export const redirect_uri = () => { 
    return getOrigin() + "/nikita-portal-app/"
}

//App main page for redirect
export const redirectState = () => {
    return btoa(getOrigin() + "/nikita-portal-app/#/portal");
}

const getOrigin = () => {
    var origin;
    if(process.env.NODE_ENV !== 'production'){
        origin = "https://nikita.windtre.it"// "https://nikitaj2c-prod-ilb.windtre.it" 
    }else{
        origin = location.origin
    }
    return origin
}